import React from "react";
import ReactDOM from "react-dom";
import EventApp from "../pageComponents/eventPage/event-page";

ReactDOM.render(<EventApp />, document.querySelector("#EventPage"));
